import { Cobranded } from "@components/common/Cobranded";
import { FathomEvent } from "@lib/constants";
import useTrackEvent from "@lib/hooks/useTrackEvent";
import { mergeGetStaticProps } from "@lib/mergeStaticProps";
import { PartnerProps, getPartnerStaticProps } from "@lib/partner";
import { ApplicationStepId } from "@modules/application/lib/applicationProcess/types";
import ApplicationProcess from "@modules/application/pages/ApplicationProcess";
import { NextPage } from "next";

const ComparePage: NextPage<PartnerProps & { stepId: string }> = ({
  partner,
  stepId,
}) => {
  useTrackEvent(FathomEvent.COMPARE);

  return (
    <Cobranded partner={partner}>
      <ApplicationProcess
        hasZeroStep={false}
        skipRealEstateAgentFee
        stepId={stepId}
        applicationType="BUY_WITH_SAVINGS"
      />
    </Cobranded>
  );
};

(ComparePage as any).applicationContextInitialValue = {
  applicationFormState: {
    values: {
      [ApplicationStepId.applicationType]: {
        applicationType: "BUY_WITH_SAVINGS",
        hasRealEstateAgentCommission: true,
      },
      [ApplicationStepId.buyWithSavingsTypeOfProperty]: {
        typeOfProperty: "APARTMENT",
      },
    },
    history: [],
  },
};

export const getStaticPaths = () => {
  return { paths: [], fallback: "blocking" };
};

export const getStaticProps = mergeGetStaticProps(
  getPartnerStaticProps,
  async ({ params }) => {
    const stepId = params?.stepId;
    return {
      props: {
        stepId,
      },
    };
  },
);

export default ComparePage;
